import React, { useContext } from 'react';

import { BooleanPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import BaseActionContext from '~/scenes/Automation/Flows/Actions/BaseActionContext';
import { FLOW_OUTPUT_TYPE } from '~/util/constants';
import PointerComponent from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/PointerComponent';
import { getStashVariablesInStash } from '~/scenes/Automation/Flows/Actions/util/stashHelpers';

type Props = {
  value: BooleanPointerParameterValue;
  onChange: (newValue: BooleanPointerParameterValue) => void;
};
const BooleanPointerParameterValueComponent = ({ value, onChange }: Props) => {
  const { variableStash } = useContext(BaseActionContext);

  return (
    <PointerComponent
      possibleVariables={getStashVariablesInStash(
        variableStash,
        undefined,
        FLOW_OUTPUT_TYPE.FlowOutputBoolean,
      )}
      fieldType={FLOW_OUTPUT_TYPE.FlowOutputBoolean}
      variable={value ? value.variable : null}
      onChange={newPointerVariable => {
        const newValue = { ...value, variable: newPointerVariable };

        onChange(newValue);
      }}
    />
  );
};

export default BooleanPointerParameterValueComponent;
